import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import NavBar from '../../components/NavBar';
import { TRANSLATION_FILES } from '../../constants/translation';
import Form from './Form';

class New extends Component {
  static propTypes = {
    token: PropTypes.string,
    location: PropTypes.shape({
      hash: PropTypes.string,
    }),
    loading: PropTypes.bool,
    onCheck: PropTypes.func,
    registerLeaveGuard: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  handleSubmit = (event) => {
    this.form.handleSubmit(event);
  }
  handleOnCheck = (hasChanges = false, callback) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges, callback);
    }
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('New')}
        />
        <Form
          ref={(ref) => { this.form = ref; }}
          onSubmit={(validations, project) => {
            this.submit(validations, project);
          }}
          onChange={this.handleOnCheck}
          registerLeaveGuard={this.props.registerLeaveGuard}
          location={this.props.location}
          loading={this.props.loading}
          token={this.props.token}
        />
      </Container>
    );
  }
}
export default withTranslation(TRANSLATION_FILES.constants)(New);



// WEBPACK FOOTER //
// ./src/containers/Bookings/New.jsx